import React from "react";
import PropTypes from "prop-types";
import { TextField as MuiTextField, Grid, Box } from "@mui/material";
import { useFormContext } from "react-hook-form";
import _ from "lodash";

import { InfoTooltip } from "components/atoms";

const TextField = ({
  name,
  rules = {},
  label,
  withError = true,
  tooltip,
  ...props
}) => {
  const { formState: { errors }, register } = useFormContext();
  const error = _.get(errors, name);
  const { ref: inputRef, ...registerProps } = register(name, rules);

  return (
    <Grid container>
      <Grid item xs>
        <MuiTextField
          {...registerProps}
          error={!!error}
          helperText={withError ? error?.message ?? "" : ""}
          label={label}
          margin="dense"
          variant="outlined"
          inputRef={inputRef}
          fullWidth={true}
          {...props}
        />
      </Grid>
      {tooltip && (
        <Grid item xs={1} component={Box} paddingTop={2}>
          <InfoTooltip>{tooltip}</InfoTooltip>
        </Grid>
      )}
    </Grid>
  );
};

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  register: PropTypes.object,
  label: PropTypes.string,
  withError: PropTypes.bool,
  tooltip: PropTypes.string,
};

export default TextField;
